export const TIPO_RECORRENCIA_PARCELA_ENUM = [
    {
        id: 'A_CADA_30_DIAS',
        descricao: "A cada 30 dias",
    },
    {
        id: 'MENSAL',
        descricao: "Mensal",
    },
    {
        id: 'ANUAL',
        descricao: "Anual",
    },
];
